import React, {Component } from 'react';
import {reactLocalStorage} from 'reactjs-localstorage';
import StoreContext from './Context';
import {VALIDAR_TOKEN,OBTENER_TOKEN } from "./../Util";

var x = reactLocalStorage.getObject('tokenP');

if(VALIDAR_TOKEN()){
  reactLocalStorage.clear();
}

class StoreProvider extends Component{
  constructor(props) {
    super(props);
    this.state = {
      token:x.token,
      compania:x.compania,
      caja_n:x.caja_n,
      usr_perfil:x.usr_perfil,
      usr_id:x.usr_id,
      usr_nombre:x.usr_nombre,
      usr_sucursal:x.usr_sucursal,
      usr_print:x.usr_print,
      usr_ajustes:x.usr_ajustes,
      usr_company:x.usr_company,
      com_suc_emisor:x.com_suc_emisor,
      usr_factura:x.usr_factura,
      usr_inventario:x.usr_inventario,
      usr_cotizacion:x.usr_cotizacion,
      usr_precio:x.usr_precio,
      usr_articulo:x.usr_articulo,
      usr_reporte:x.usr_reporte,
      usr_a_costo:x.usr_a_costo,
      usr_apartado:x.usr_apartado,
      usr_gastos:x.usr_gastos,
      dataCompania:x.dataCompania,
      cajaData:x.cajaData,
      usr_clientes:x.usr_clientes,
      usr_key_login:x.usr_key_login,
      children: props.children,
      key:x.key,
      dataFacturaDetallePr:props.children
    };
    this.setdataFacturaDetallePr = this.setdataFacturaDetallePr.bind(this);
    this.setToken = this.setToken.bind(this);
    this.quitToken = this.quitToken.bind(this);
  }
  setdataFacturaDetallePr = ({dataFacturaDetallePr})=> {
    this.setState({
      dataFacturaDetallePr:dataFacturaDetallePr
    });
    reactLocalStorage.setObject('tokenP',{...this.state,dataFacturaDetallePr});
    }
  setToken = ({token,compania,caja_n, usr_perfil, usr_id,usr_nombre,usr_sucursal,usr_print, usr_ajustes,usr_company,com_suc_emisor,
    usr_factura,
    usr_inventario,
    usr_cotizacion,
    usr_articulo,
    usr_precio,
    usr_reporte,usr_apartado,usr_gastos,usr_a_costo,dataCompania,cajaData,usr_clientes,usr_key_login})=> {
    const props = this.state;
    const keyToken = OBTENER_TOKEN({usr_perfil:usr_perfil,usr_id:usr_id,usr_nombre:usr_nombre,usr_sucursal:usr_sucursal,usr_print:usr_print,
      usr_ajustes:usr_ajustes,
      usr_company:usr_company,
      com_suc_emisor:com_suc_emisor,
      usr_factura:usr_factura,
      usr_inventario:usr_inventario,
      usr_cotizacion:usr_cotizacion,
      usr_articulo:usr_articulo,
      usr_apartado:usr_apartado,
      usr_gastos:usr_gastos,
      dataCompania:dataCompania,
      cajaData:cajaData,
      usr_clientes:usr_clientes,
      usr_precio:usr_precio,
      usr_a_costo:usr_a_costo,
      usr_reporte:usr_reporte,usr_key_login:usr_key_login,
      compania:compania,
      caja_n:caja_n})
    this.setState({
      token,
      usr_perfil,
      usr_id,
      usr_nombre,
      usr_sucursal,
      usr_print,
      usr_ajustes,
      usr_company,
      com_suc_emisor,
      usr_factura,
      usr_inventario,
      usr_cotizacion,
      usr_articulo,
      usr_reporte,
      usr_a_costo,
      usr_apartado,
      usr_gastos,
      dataCompania,
      cajaData,
      usr_clientes,
      usr_precio,
      usr_key_login,
      compania,
      caja_n,
      key:keyToken
    });
    reactLocalStorage.setObject('tokenP',{token,usr_perfil,usr_id,usr_nombre,usr_sucursal,usr_print,usr_ajustes,usr_company,
      usr_factura,
      usr_inventario,
      usr_cotizacion,
      usr_articulo,
      usr_apartado,
      usr_gastos,
      usr_a_costo,
      dataCompania,
      cajaData,
      usr_clientes,
      usr_precio,
      usr_key_login,
      compania,
      com_suc_emisor,
      caja_n,
      usr_reporte,key:keyToken,});
  }

  quitToken = ()=> {
    this.setState({
      token:"",
      usr_perfil:"",
      usr_id:"",
      usr_nombre:"",
      usr_sucursal:"",
      usr_print:"",
      usr_ajustes:"",
      usr_company:"",
      com_suc_emisor:"",
      usr_factura:"",
      usr_inventario:"",
      usr_cotizacion:"",
      usr_articulo:"",
      usr_reporte:"",
      usr_a_costo:"",
      usr_apartado:"",
      usr_gastos:"",
      dataCompania:[],
      cajaData:[],
      usr_clientes:"",
      usr_precio:"",
      compania:"",
      caja_n:"",
      key:""
    });
    reactLocalStorage.clear();
  }
  
  render() {
    const props= this.state;
    return (
      <StoreContext.Provider value={{token:props.token,usr_perfil:props.usr_perfil,usr_id:props.usr_id,
        usr_nombre:props.usr_nombre,usr_sucursal:props.usr_sucursal,usr_print:props.usr_print,usr_company:props.usr_company, com_suc_emisor:props.com_suc_emisor,usr_ajustes:props.usr_ajustes,
        usr_factura:props.usr_factura,
        usr_inventario:props.usr_inventario,
        usr_cotizacion:props.usr_cotizacion,
        usr_articulo:props.usr_articulo,
        usr_reporte:props.usr_reporte,key:props.key,
        usr_a_costo:props.usr_a_costo,
        usr_apartado:props.usr_apartado,
        usr_gastos:props.usr_gastos,
        dataCompania:props.dataCompania,
        cajaData:props.cajaData,
        usr_clientes:props.usr_clientes,
        compania:props.compania,
        caja_n:props.caja_n,
        usr_precio:props.usr_precio,usr_key_login:props.usr_key_login,dataFacturaDetallePr:props.dataFacturaDetallePr,
      setToken:this.setToken,quitToken:this.quitToken,setdataFacturaDetallePr:this.setdataFacturaDetallePr}}>
            {props.children}
      </StoreContext.Provider>
    );
  }
}

export default StoreProvider;